module.exports = __webpack_public_path__ + "img/20200313120300081.850c2028.png";